import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import * as thunks from 'features/thunks'
import PlayerRole from './player-role-model'
import {
  CreatePlayerRoleAsync,
  DeletePlayerRoleAsync,
  LoadPlayerRolesAsync,
} from './playerRole-thunk'
const initialState: playerRoleSliceState = {
  playerRole: [],
  selected_playerRole: '',
  is_loading_playerRole: false,
  is_creating_playerRole: false,
  is_deleting_playerRole: false,
}
export interface playerRoleSliceState {
  playerRole: PlayerRole[]
  selected_playerRole?: string
  is_loading_playerRole: boolean
  is_creating_playerRole: boolean
  is_deleting_playerRole: boolean
}
export const playerRoleSlice = createSlice({
  name: 'playerRole',
  initialState,
  reducers: {
    setSelectedplayerRole: (state, action) => {
      state.selected_playerRole = action.payload
    },
    clearStateplayerRole: (state) => {
      state.playerRole = []
      state.is_loading_playerRole = false
      state.is_creating_playerRole = false
      state.is_deleting_playerRole = false
    },
    mergeplayerRole: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_playerRole = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.playerRole = merge(state.playerRole, payload) as any
        }
      }
    },

    add_playerRole: (state, action) => {
      if (action.payload) {
        state.playerRole = [...state.playerRole, action.payload]
      }
    },
    set_playerRole: (state, action) => {
      let { key, value, id } = action.payload
      state.playerRole = state.playerRole.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(thunks.GetPlayerRolesForPlayerAsync.pending, (state) => {
      state.is_loading_playerRole = true
    })
    builder.addCase(
      thunks.GetPlayerRolesForPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_playerRole = false
        handleResult(action, state)
      },
    )
    builder.addCase(thunks.GetPlayerRolesForPlayerAsync.rejected, (state) => {
      state.is_loading_playerRole = false
    })

    builder.addCase(thunks.DeletePlayerRoleAsync.pending, (state) => {
      state.is_loading_playerRole = true
    })
    builder.addCase(thunks.DeletePlayerRoleAsync.fulfilled, (state, action) => {
      state.is_loading_playerRole = false
      handleResult(action, state)
    })
    builder.addCase(thunks.DeletePlayerRoleAsync.rejected, (state) => {
      state.is_loading_playerRole = false
    })

    builder.addCase(thunks.CreateUpdatePlayerRoleAsync.pending, (state) => {
      state.is_loading_playerRole = true
    })
    builder.addCase(
      thunks.CreateUpdatePlayerRoleAsync.fulfilled,
      (state, action) => {
        state.is_loading_playerRole = false
        handleResult(action, state)
      },
    )
    builder.addCase(thunks.CreateUpdatePlayerRoleAsync.rejected, (state) => {
      state.is_loading_playerRole = false
    })

    builder.addCase(thunks.GetPlayerRolesAsync.pending, (state) => {
      state.is_loading_playerRole = true
    })
    builder.addCase(thunks.GetPlayerRolesAsync.fulfilled, (state, action) => {
      state.is_loading_playerRole = false
      handleResult(action, state)
    })
    builder.addCase(thunks.GetPlayerRolesAsync.rejected, (state) => {
      state.is_loading_playerRole = false
    })

    builder.addCase(thunks.GetPlayerRoleByIdAsync.pending, (state) => {
      state.is_loading_playerRole = true
    })
    builder.addCase(
      thunks.GetPlayerRoleByIdAsync.fulfilled,
      (state, action) => {
        state.is_loading_playerRole = false
        handleResult(action, state)
      },
    )
    builder.addCase(thunks.GetPlayerRoleByIdAsync.rejected, (state) => {
      state.is_loading_playerRole = false
    })

    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPlayerRolesAsync.pending, (state) => {
      state.is_loading_playerRole = true
    })
    builder.addCase(LoadPlayerRolesAsync.fulfilled, (state, action) => {
      state.is_loading_playerRole = false
      if (action.payload) {
        state.playerRole = action.payload
      }
    })
    builder.addCase(LoadPlayerRolesAsync.rejected, (state) => {
      state.is_loading_playerRole = false
    })
    builder.addCase(CreatePlayerRoleAsync.pending, (state) => {
      state.is_creating_playerRole = true
    })
    builder.addCase(CreatePlayerRoleAsync.fulfilled, (state) => {
      state.is_creating_playerRole = false
    })
    builder.addCase(CreatePlayerRoleAsync.rejected, (state) => {
      state.is_creating_playerRole = false
    })
    builder.addCase(DeletePlayerRoleAsync.pending, (state) => {
      state.is_deleting_playerRole = true
    })
    builder.addCase(DeletePlayerRoleAsync.fulfilled, (state, action) => {
      state.is_deleting_playerRole = false
      if (state.playerRole) {
        state.playerRole = state.playerRole.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePlayerRoleAsync.rejected, (state) => {
      state.is_deleting_playerRole = false
    })

    builder.addCase(
      autoThunks.CreateItemPlayerRole_byPlayerAsync.pending,
      (state) => {
        state.is_loading_playerRole = true
      },
    )
    builder.addCase(
      autoThunks.CreateItemPlayerRole_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_playerRole = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.CreateItemPlayerRole_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_playerRole = false
      },
    )

    builder.addCase(
      autoThunks.UpdateItemPlayerRole_byPlayerAsync.pending,
      (state) => {
        state.is_loading_playerRole = true
      },
    )
    builder.addCase(
      autoThunks.UpdateItemPlayerRole_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_playerRole = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.UpdateItemPlayerRole_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_playerRole = false
      },
    )

    builder.addCase(
      autoThunks.DeleteItemPlayerRole_byPlayerAsync.pending,
      (state) => {
        state.is_loading_playerRole = true
      },
    )
    builder.addCase(
      autoThunks.DeleteItemPlayerRole_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_playerRole = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.DeleteItemPlayerRole_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_playerRole = false
      },
    )

    builder.addCase(
      autoThunks.GetItemPlayerRole_byPlayerAsync.pending,
      (state) => {
        state.is_loading_playerRole = true
      },
    )
    builder.addCase(
      autoThunks.GetItemPlayerRole_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_playerRole = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.GetItemPlayerRole_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_playerRole = false
      },
    )

    builder.addCase(
      autoThunks.GetListPlayerRole_byPlayerAsync.pending,
      (state) => {
        state.is_loading_playerRole = true
      },
    )
    builder.addCase(
      autoThunks.GetListPlayerRole_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_playerRole = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.GetListPlayerRole_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_playerRole = false
      },
    )
  },
})

function handleResult(action: any, state: playerRoleSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_playerRole = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.playerRole = merge(state.playerRole, payload) as any
    }
  }
}

export const {
  clearStateplayerRole,
  setSelectedplayerRole,
  set_playerRole,
  mergeplayerRole,
  add_playerRole,
} = playerRoleSlice.actions

export const get_playerRole =
  (id?: string) =>
  (state: {
    playerRole: {
      playerRole: PlayerRole[]
    }
  }): PlayerRole | null => {
    let temp = state?.playerRole?.playerRole?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.playerRole?.playerRole[0] || null
  }
export const get_selected_playerRole = (state: {
  playerRole: playerRoleSliceState
}): PlayerRole | null => {
  let id = state?.playerRole?.selected_playerRole
  let temp = state?.playerRole?.playerRole?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_playerRole = (state: {
  playerRole: {
    playerRole: PlayerRole[]
  }
}): PlayerRole[] => {
  let temp = state?.playerRole?.playerRole
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_playerRole_busy = (state: {
  playerRole: playerRoleSliceState
}) => {
  return (
    state?.playerRole.is_deleting_playerRole ||
    state?.playerRole.is_loading_playerRole ||
    state?.playerRole.is_creating_playerRole
  )
}
export const is_deleting_playerRole_busy = (state: {
  playerRole: playerRoleSliceState
}) => {
  return state?.playerRole.is_deleting_playerRole
}
export const is_loading_playerRole_busy = (state: {
  playerRole: playerRoleSliceState
}) => {
  return state?.playerRole.is_loading_playerRole
}
export const is_creating_playerRole_busy = (state: {
  playerRole: playerRoleSliceState
}) => {
  return state?.playerRole.is_creating_playerRole
}

export default playerRoleSlice.reducer
